// Pricing plans
export const PRICING_PLANS = [
  {
    id: 'basic',
    name: 'Basic',
    price: 100000,
    totalApps: 60,
    paymentNote: 'One-time full payment',
    features: [
      'Professional CV Edit & Optimization',
      'Tailored Cover Letters',
      '60 Strategic Applications',
      'Dedicated Gmail Account Setup',
      'Email Support',
    ],
    popular: false,
  },
  {
    id: 'standard',
    name: 'Standard',
    price: 150000,
    totalApps: 80,
    paymentNote: 'One-time full payment',
    features: [
      'Everything in Basic',
      '80 Strategic Applications',
      'LinkedIn Profile Optimization',
      'Local & International Job Targeting',
      'Priority Email Support',
    ],
    popular: true,
  },
  {
    id: 'premium',
    name: 'Premium',
    price: 200000,
    totalApps: 120,
    paymentNote: 'One-time full payment',
    features: [
      'Everything in Standard',
      '120 Strategic Applications',
      'Global Remote & Japa Job Access',
      '1-on-1 Strategy Session (45 to 60 min)',
      'Salary Negotiation Tips',
    ],
    popular: false,
  },
];

// Navigation items
export const NAV_ITEMS = [
  { label: 'Services', id: 'services' },
  { label: 'Process', id: 'process' },
  { label: 'Pricing', id: 'pricing' },
  { label: 'Jobs', id: 'jobs' },
  { label: 'Success Stories', id: 'success-stories' },
];

// Stats data
export const STATS_DATA = [
  { value: '500+', label: 'Clients Helped' },
  { value: '85%', label: 'Interview Rate' },
  { value: '12', label: 'Countries Reached' },
  { value: '4.9/5', label: 'Client Rating' },
];

// Services data
export const SERVICES_DATA = [
  {
    id: 'cv-optimization',
    icon: 'FileText',
    title: 'CV Edit & Optimization',
    description: 'Professional CV rewriting and ATS optimization, crafted to get you past automated screening and onto hiring managers desks.',
    color: 'from-blue-500 to-indigo-500',
  },
  {
    id: 'strategic-applications',
    icon: 'Globe',
    title: 'Strategic Job Applications',
    description: 'We apply on your behalf, using targeted applications across local and international markets tailored to your profile and career goals.',
    color: 'from-violet-500 to-purple-500',
  },
  {
    id: 'cover-letters',
    icon: 'PenLine',
    title: 'Tailored Cover Letters',
    description: 'Compelling, role-specific cover letters written to complement your CV and make you stand out from the competition.',
    color: 'from-amber-500 to-orange-500',
  },
];

// Process steps
export const PROCESS_STEPS = [
  {
    step: '01',
    title: 'Initial Consultation & CV Revamp',
    description: 'Contact us to discuss your target roles. We will completely re-tailor your CV and profile for the specific job you want, even if you are pivoting careers.',
    icon: 'Users',
  },
  {
    step: '02',
    title: 'Payment & Account Setup',
    description: 'Once payment is confirmed, we create a dedicated Gmail account specifically for your job search and share all the credentials with you.',
    icon: 'Zap',
  },
  {
    step: '03',
    title: 'Strategic Applications',
    description: 'We use the dedicated email to apply for jobs on your behalf. You have full transparency and can monitor all incoming responses.',
    icon: 'Briefcase',
  },
  {
    step: '04',
    title: 'Interviews & Placement',
    description: 'We notify you when you land an interview. Once you secure the job, a pre-agreed percentage placement fee is collected.',
    icon: 'TrendingUp',
  },
];

// Testimonials
export const TESTIMONIALS_DATA = [
  {
    id: 1,
    name: 'Chioma A.',
    role: 'Software Engineer',
    company: 'Google (Remote)',
    quote: 'Went from 0 interviews to 5 offers in 6 weeks. The strategic approach to applications made all the difference.',
    image: 'bg-gradient-to-br from-blue-400 to-indigo-500',
    rating: 5,
  },
  {
    id: 2,
    name: 'Michael O.',
    role: 'Product Manager',
    company: 'PayPal',
    quote: 'Finally broke into the UK tech scene. The CV rewrite alone was worth 10x what I paid.',
    image: 'bg-gradient-to-br from-violet-400 to-purple-500',
    rating: 5,
  },
  {
    id: 3,
    name: 'Sarah L.',
    role: 'Marketing Director',
    company: 'Unilever Canada',
    quote: 'Professional, dedicated, and results-driven. Landed my dream role in Canada within the first month.',
    image: 'bg-gradient-to-br from-amber-400 to-orange-500',
    rating: 5,
  },
];

// FAQ data
export const FAQ_DATA = [
  {
    question: 'Do you guarantee job placement?',
    answer: 'We do not guarantee job placement. We provide the tools and strategy, the final hiring decision rests solely with the employer. We guarantee our dedication, process quality, and the number of applications submitted.',
  },
  {
    question: 'How long does the process take?',
    answer: 'Most clients see results within 4 to 8 weeks, depending on the package selected and market conditions. This covers the full cycle: CV audit, application phase, and interview responses.',
  },
  {
    question: 'What if I am not satisfied?',
    answer: 'We offer a 2-week service extension to optimize results at no extra cost. Due to the immediate work involved (CV review, cover letters), we do not offer refunds after 24 hours or once document review has begun.',
  },
  {
    question: 'Can I target international and remote jobs?',
    answer: 'Absolutely! We specialize in helping Nigerian talent access remote US, UK, Canada, and EU opportunities.',
  },
  {
    question: 'How does booking work after payment?',
    answer: 'After payment, you upload your CV on the website. Once we verify your payment or receipt, your booking calendar is unlocked. We respond to all bookings within 24 hours. Sessions are 45 to 60 minutes via Google Meet.',
  },
  {
    question: 'What are your working hours?',
    answer: 'We are available Monday–Thursday (10 AM – 4 PM) and Saturday (10 AM – 2 PM) WAT. All sessions are conducted via Google Meet.',
  },
];

// Contact info
export const CONTACT_INFO = {
  email: 'placementpoint.job@gmail.com',
  phone: '+234 708 637 1665',
  whatsapp: '+234 802 320 0783',
  whatsappRaw: '2348023200783',
  address: 'Lagos, Nigeria',
  availability: 'Mon to Thu & Sat',
  consultationDuration: '45 to 60 minutes',
  platform: 'Google Meet',
  workingHours: 'Mon to Thu: 10 AM to 4 PM, Sat: 10 AM to 2 PM',
};
